import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent {
  @Input() profile = null;
  @Input() taxConditions = [];
  @Input() typeCompany = '';
  @Input() years = '';
}
